export interface ServerToClientMessageBO<T> {
  cmd?: string;
  collection?: string;
  data: T;
  hasError: boolean;
  errorMessage: boolean;
}

export interface CollectionWsMessage<T> {
  action: CollectionAction;
  status: Status;
  data: T;
  collection: string;
}
export interface AlertsCollectionActionWsMessage<T> {
  action: AlertsCollectionAction;
  data: T;
  collection: string;
}

export interface CollectionNotificationWsMessage {
  message: string;
  type: string;
  timeout: number;
}

export enum Status {
  OK = 'OK',
  ERROR = 'ERROR',
}

export enum CollectionAction {
  ADD = 'ADD',
  UPDATE = 'UPDATE',
  REMOVE = 'REMOVE',
  GET = 'GET',
  ALL = 'ALL',
  POPULATE = 'POPULATE',
  DROP_ALL = 'DROP_ALL',
}

export enum AlertsCollectionAction {
  UPDATED = 'UPDATED',
  CREATED = 'CREATED',
  REMOVED = 'REMOVED',
}

export interface TickerCommandPayload<T> {
  correlationId?: number;
  collection: string;
  tickerId: number;
  data?: T;
  cmd: string;
}
